import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Directions,
  boatTypeEnumReversed,
  dashboardConstants,
  levelEnumReversed,
  modeConstants,
  proficiencyLevelEnumReversed,
  timezoneConstants,
  translationConstants,
  viewPathConstants,
} from "../../../../../constants";
import nationalScore from "../../../../../assets/images/dashboard/score.png";
import nationalRanking from "../../../../../assets/images/dashboard/ranking.png";
import { useDispatch, useSelector } from "react-redux";
import { DashboardActions, UserActions } from "../../../../../redux/actions";
import StatCard from "./StatCard";
import TableCard from "./TableCard";
import { useNavigate } from "react-router-dom";
import { CourseActions } from "../../../../../redux/actions/course.action";
import CustomModal from "../../../../../shared/components/CustomModal/CustomModal";
import CourseModal from "../../../../../shared/components/CourseModal/CourseModal";
import {
  formatDateTOString,
  getLevelAndProficiencyLevel,
  replaceSportsIdWithName,
  serverFormatToDateString,
} from "../../../../../system";
import moment from "moment";
import { render } from "@testing-library/react";
import { TableViewIcon } from "../../../../../assets/images/icon/iconsProvider";

const DashboardContent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const [mode, setMode] = useState(modeConstants.ADD_MODE);

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const getRowData = (data) => {
    dispatch(CourseActions.getStudentById(data.id));
    setIsShow(true);
  };

  const onSetShow = () => {
    setIsShow((prev) => !prev);
  };

  const {
    nationalStats,
    previousCompetitiones,
    registeredCompetitiones,
    courses,
  } = useSelector((state) => state.dashboardReducer?.dashboardData);

  const pageSize = 4;

  const userSports = useSelector((state) => state.UserReducer?.userSports);
  useEffect(() => {
    dispatch(DashboardActions.getDashboardData(systemUserId, pageSize));
    dispatch(UserActions.getUserSportsById(systemUserId));
    // eslint-disable-next-line
  }, []);

  const previousCompetitionsColumns = [
    {
      header: `${t(translationConstants.COMPETITIONS_NAME)}`,
      key: "title",
    },
    { header: `${t(translationConstants.RANK)}`, key: "ranking" },
  ];

  const registeredCompetitionsColumns = [
    {
      header: `${t(translationConstants.COMPETITIONS_NAME)}`,
      key: "title",
    },
    {
      header: `${t("")}`,
      key: "viewMore",
      render: (row) => (
        <span
          onClick={() => {
            navigate(`${viewPathConstants.MY_COMPETITIONS_DETAIL}`, {
              state: { competitionId: row?.id, isCancelled: true },
            });
          }}
          className="font-12 underline py-md-4 cursor-pointer text-dark-green"
        >
          {t(translationConstants.VIEW_MORE)}
        </span>
      ),
    },
  ];

  const coursesColumns = [
    {
      header: `${t(translationConstants.instructor)}`,
      key: "instructorName",
      render: (row) =>
        direction === Directions.rtl && row?.instructorArabicName
          ? row?.instructorArabicName
          : row?.instructorName,
    },
    {
      header: `${t(translationConstants.SPORT)}`,
      key: "sportId",
      render: (row) => <>{replaceSportsIdWithName(row.sportId, t)}</>,
    },
    {
      header: `${t(translationConstants.BOAT_TYPE)}`,
      key: "boatTypeId",
      render: (row) =>
        t(translationConstants[boatTypeEnumReversed[row.boatTypeId]]),
    },
    {
      header: `${t(translationConstants.LEVEL)}`,
      key: "levelId",
      render: (row) =>
        row.levelId
          ? getLevelAndProficiencyLevel(t, row.levelId, row.proficiencyLevelId)
          : row.isGeneralTraining && row.levelId === null
          ? t(translationConstants.GENERAL_TRAINING)
          : "--",
    },
    { header: `${t(translationConstants.HOURS)}`, key: "hoursSpend" },
    {
      header: `${t(translationConstants.Actions)}`,
      key: "Actions",
      render: (row) => (
        <div
          onClick={() => {
            getRowData(row);
            setMode(modeConstants.VIEW_MODE);
          }}
          className="cursor-pointer"
        >
          <TableViewIcon />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="dashboard-main-content mb-4">
        {/* Temporarily Hide the National Ranking Components */}
        {/* <div className="row">
          <div className="col-6 dashboard-main-content">
            <StatCard
              col={12}
              nationalStats={nationalStats}
              statType={dashboardConstants.RANKING}
              image={nationalRanking}
              isCompetition={true}
              userSports={userSports}
            />
          </div>
          <div className="col-6 dashboard-main-content">
            <StatCard
              col={12}
              nationalStats={nationalStats}
              statType={dashboardConstants.SCORE}
              image={nationalScore}
              isCompetition={true}
              userSports={userSports}
            />
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-6 col-12">
            <TableCard
              title={t(translationConstants.REGISTERED_COMPETITIONS)}
              columns={registeredCompetitionsColumns}
              data={registeredCompetitiones}
              headerColor="text-purple"
              classNameViewAll="dashboard-card-text-view-all text-dark-green"
              classNameTableHeader="dashboard-card-table-heading"
              rowBackground={"lightestPurple"}
              viewAllLink={viewPathConstants.My_COMPETITIONS}
              isCompetitionCard={true}
              tag={translationConstants.REGISTERED_COMPETITIONS}
            />
          </div>
          <div className="col-md-6 col-12">
            <TableCard
              title={t(translationConstants.PREVIOUS_COMPETITIONS)}
              columns={previousCompetitionsColumns}
              data={previousCompetitiones}
              classNameViewAll="dashboard-card-text-view-all text-dark-green"
              classNameTableHeader="dashboard-card-table-heading"
              viewAllLink={viewPathConstants.My_COMPETITIONS}
              isCompetitionCard={true}
              rowBackground={"lightestPurple"}
            />
          </div>
          <div className="col-12">
            <TableCard
              isShowTimezone={true}
              title={t(translationConstants.COURSES_HISTORY)}
              columns={coursesColumns}
              data={courses}
              viewAllLink={viewPathConstants.STUDENT_COURSES}
              classNameViewAll="dashboard-card-text-view-all text-dark-green"
              classNameTableHeader="dashboard-card-table-heading"
              rowBackground={"lightestGreen"}
            />
          </div>
        </div>
        <CustomModal
          size="lg"
          scrollable
          show={isShow}
          setShow={onSetShow}
          customClass="view-user-modal"
        >
          <CourseModal setShow={setIsShow} mode={mode} />
        </CustomModal>
      </div>
    </>
  );
};

export default DashboardContent;
